import { render, staticRenderFns } from "./BackgroundConfig.v2.vue?vue&type=template&id=7e4776d2&scoped=true&"
import script from "./BackgroundConfig.v2.vue?vue&type=script&lang=js&"
export * from "./BackgroundConfig.v2.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundConfig.v2.vue?vue&type=style&index=0&id=7e4776d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4776d2",
  null
  
)

export default component.exports